export default function cleanRecipient(rawRecipient: Office.EmailAddressDetails): Office.EmailAddressDetails {
  const recipient = {} as Office.EmailAddressDetails

  if (recipient) {
    recipient.emailAddress = rawRecipient.emailAddress
    recipient.displayName = rawRecipient.displayName
  }

  return recipient
}
